module.exports = __webpack_public_path__ + "img/xmjkzxt2.b9ae2a0b.jpg";